export default (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_ORDERS':
      return { ...state, ...action.p }
    default:
      return state;
  }
};


// selectors

export const getPreorders = orders => {
  return Object.keys(orders).reduce((res, key) => {
    return orders[key].status === 0 ? res.concat(orders[key]) : res;
  }, [])
}

export const getConfirmed = orders => {
  return Object.keys(orders).reduce((res, key) => {
    return orders[key].status === 1 || orders[key].status === 2 ? res.concat(orders[key]) : res;
  }, [])
}

export const getCompleted = orders => {
  return Object.keys(orders).reduce((res, key) => {
    return orders[key].status === 3 ? res.concat(orders[key]) : res;
  }, [])
}



// WEBPACK FOOTER //
// ./src/store/reducers/orders.js